import { render, staticRenderFns } from "./NsProductDetail.vue?vue&type=template&id=ad76a272&"
import script from "./NsProductDetail.vue?vue&type=script&lang=js&"
export * from "./NsProductDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports